import 'isomorphic-fetch';
import urijs from 'urijs';
import isObjectLike from 'lodash.isobjectlike';

export function serverApi(api, payload, method = 'POST', objUrlParams) {
  return serverControllerApi(api, '', payload, method, objUrlParams);
}

export function serverControllerApi(api, controller, payload, method = 'POST', objUrlParams) {
  let body = payload;

  if (isObjectLike(payload)) {
    body = JSON.stringify(payload);
  }

  return fetchx(urijs.joinPaths(window.__SERVERBASE__, controller, `/api/${api}`), {
    method,
    body
  }, objUrlParams);
}

export function fetchx(uriObject, options, objUrlParams) {
  const headers = new Headers({
    Accept: 'application/json',
    'content-type': 'application/json'
  });
  const pInstance = window.__pINSTANCE__;
  const galleryId = window.__GALLERYID__;
  const debugApp = window.__DEBUG_APP__;
  if (pInstance) {
    uriObject.addSearch('pInstance', pInstance);
  }
  if (galleryId) {
    uriObject.addSearch('galleryId', galleryId);
  }
  if (debugApp) {
    uriObject.addSearch('debugApp', debugApp);
  }

  addParamsObjectToUriObject(uriObject, objUrlParams);

  const fetchOptions = Object.assign({
    headers,
    credentials: 'same-origin',
    method: 'POST'
  }, options);

  return fetch(uriObject.toString(), fetchOptions)
    .then(response => {
      if (response.status >= 400) {
        throw response;
      }

      return response.json();
    })
    .catch(responseError => { // Prevent sagas from throwing exceptions
      return { responseError };
    });
}

export function getShopControllerUrl(controller, objUrlParams) {
  const pInstance = window.__pINSTANCE__;
  const uriObject = urijs.joinPaths(window.__SERVERBASE__, controller);
  if (pInstance) {
    uriObject.addSearch('pInstance', pInstance);
  }

  addParamsObjectToUriObject(uriObject, objUrlParams);

  return uriObject.toString();
}

function addParamsObjectToUriObject(uriObject, objUrlParams) {
  if (objUrlParams && isObjectLike(objUrlParams)) {
    for (const key in objUrlParams) {
      if (objUrlParams.hasOwnProperty(key)) {
        const value = objUrlParams[key];
        uriObject.addSearch(key, value);
      }
    }
  }
}
